import React, { useState } from 'react'
import toast from 'react-hot-toast'
import { FaEye } from "react-icons/fa";
import { FaEyeSlash } from "react-icons/fa";
import { useDispatch } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';
import { getUser } from '../Redux/loginUserSlice';
import FullScreenLoader from './FullScreenLoader';
import Footer from './Footer';
const Login = () => {
  const [view, setView] = useState(false)
  const [loading, setLoading] = useState(false)
  const navigate = useNavigate()
  const dispatch = useDispatch()

  const BASE_URl = window.location.origin

  const handleLogin = (e) => {
    e.preventDefault()
    const formData = {
      email: e.target.email.value,
      password: e.target.password.value,
    }
    setLoading(true)
    fetch(`${BASE_URl}/api/login`, {
      method: 'POST',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(formData)
    }).then((res) => res.json())
    .then((data) => {
      if(data&&data.sucess === true){
        setLoading(false)
        dispatch(getUser(data.user))
        toast(data.message)
        navigate('/')
      } else if(data && data.sucess === false){
        setLoading(false)
        toast(data.message)
      }
    })
    .catch((error) => {
      if(error) {
        setLoading(false)
        toast(error.message)
      }
    })

    e.target.reset()
  }

  return (
    <>
    <div className='mt-24 flex flex-col items-center h-[80vh] pb-14'>
      <h1 className='text-center mb-8 text-3xl font-serif'>Login</h1>
      {loading?<FullScreenLoader/>:null}
      <form onSubmit={handleLogin} className='flex flex-col items-center justify-evenly gap-2 w-[90%] h-[90%] bg-blue-300 p-3 rounded-[10px] sm:w-[80%] lg:w-[70%]'>
        <input required type="email" placeholder='Your Email' name="email" className='border-[0.5px] p-2 outline-0 rounded-[8px] w-[80%] active:bg-none placeholder:text-black '/>
        <div className='w-[80%] flex items-center'>
            <input required type={view?'text':'password'} placeholder='Your Password' name="password" className=' p-2 outline-0 w-[100%] active:bg-none placeholder:text-black ' style={{borderLeft: '0.5px solid black', borderTop: '0.5px solid black', borderBottom: '0.5px solid black', borderTopLeftRadius: '8px', borderBottomLeftRadius: '8px'}}/>
            <span onClick={()=>{setView(!view)}} className='cursor-pointer p-2 text-2xl' style={{borderRight: '0.5px solid black', borderTop: '0.5px solid black', borderBottom: '0.5px solid black', borderTopRightRadius: '8px', borderBottomRightRadius: '8px'}}>{view?<FaEyeSlash/>:<FaEye/>}</span>
        </div>
        <div className='w-[80%] flex justify-start'>
  <Link to={'/auth/forgetpassword'} className="text-blue-600 hover:underline">Forget Password</Link>
</div>

        <div className='w-[80%] flex justify-evenly'>
          <button type='reset' className='cursor-pointer border-[0.5px] p-3 rounded-2xl hover:bg-blue-200' style={{transition: '0.5s'}}>Reset</button>
          <button type='submit' className='cursor-pointer border-[0.5px] p-3 rounded-2xl bg-blue-200 hover:bg-blue-300' style={{transition: '0.5s'}}>Login</button>
        </div>
        <p>Not have Account ? <Link to="/auth/singup">Register Now</Link></p>
      </form>

    </div>
    
      <Footer/>
    </>
  )
}

export default Login
 